import { useEffect, type FC } from "react";
import { Route, Routes } from "react-router-dom";

import { Sidebar } from "./components/Sidebar";
import { Fallback } from "./Fallback";
import { PlaylistAdminContent } from "./Playlist";
import { Users } from "./Users";

import { type AxiosResponse } from "axios";
import { type FallbackVideoPaginatedResult } from "../../api/generated/data-contracts";
import { useDispatch } from "react-redux";
import { useTypedSelector } from "../../redux/store";
import { setSongs, setSongsLoading } from "../../redux/slices/fallbackSongs";
import { logout } from "../../redux/slices/auth";
import { getAllFallbackSongs } from "../../utils/getAll";

import "./styles.scss";

export const SIDEBAR_WIDTH = 250;

export const AdminPage: FC = () => {
  const dispatch = useDispatch();
  const userJwt = useTypedSelector((state) => state.auth.value);

  useEffect(() => {
    const handleSet = (
      res: AxiosResponse<FallbackVideoPaginatedResult, any>
    ): void => {
      dispatch(setSongs(res?.data?.results ?? []));
    };
    const afterCatch = (): void => {
      dispatch(setSongsLoading(false));
    };
    const handle401 = (): void => {
      dispatch(logout());
    };

    getAllFallbackSongs(userJwt, handleSet, afterCatch, handle401);
  }, [dispatch, userJwt]);

  return (
    // this code was taken from MUI docs
    <div className="page-admin">
      <Sidebar />
      <div
        className="page-admin__content"
        style={{ width: `calc(100% - ${SIDEBAR_WIDTH}px)` }}
      >
        <Routes>
          <Route index element={<PlaylistAdminContent />} />
          <Route path="/fallback" element={<Fallback />} />
          <Route path="/users" element={<Users />} />

          {/* <Route path="/loguot" element={<div>Logout</div>} /> */}
        </Routes>
      </div>
    </div>
  );
};
